import React from 'react';
import classnames from 'classnames';
import PartyFoulIcon from 'images/icons/party-foul.svg?react-svg';
import { SecondarySmallUppercase, H2Alt, H3 } from 'scy/text';
import { mutedAccent } from 'scy/text/styles.mod.scss';
import { pageContainer, borderBox, textCenter } from 'scy/utils.mod.scss';
import { flex, column, centerContent } from 'scy/flex.mod.scss';
import margin from 'scy/margin.mod.scss';

export default function NotFoundPage() {
  return (
    <section
      className={classnames(
        pageContainer,
        borderBox,
        margin.md,
        textCenter,
        flex,
        column,
        centerContent
      )}
    >
      <div className={classnames(mutedAccent, margin.md)}>
        <PartyFoulIcon />
      </div>
      <SecondarySmallUppercase
        tag="h1"
        marginClass={classnames(margin.top_0, margin.bottom_sm)}
      >
        404
      </SecondarySmallUppercase>
      <H2Alt>Party foul.</H2Alt>
      <H3 marginClass={margin.md}>We’ll clean up. You head back in there.</H3>
    </section>
  );
}
